<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-user-employees-detail">

        <page-title :title="'Szczegóły pracownika'" :back="true"></page-title>

        <div v-if="loading" class="text-center">
            <span class="loader gold"></span>
        </div>
        <div v-else>
            <slide-x-left-transition :duration="400" :delay="200">
                <div v-if="show" style="padding: 15px 0">
                    <h6 class="text-up m-0">Profil</h6>
                    <hr>
                    <h3 style="margin:5px 0">{{ employee.first_name }} {{ employee.last_name }}</h3>
                    <ion-progress-bar :value="progressValue" style="height:15; margin-top: 15px"></ion-progress-bar>
                    <p v-show="show" style="margin: 10px 0; font-size: 12px">
                        <strong>Lekcje {{ employee.number_pass_tests }}z{{ employee.number_trainings_tests }}</strong>
                    </p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="500" :delay="300">
                <div v-if="show">
                    <h6 class="text-up m-0">Role</h6>
                    <hr>
                    <div v-for="(item,index) in employee.roles" :key="index" class="mt-10">
                        <p class="mb-0">
                            <svg v-if="item.verified" class="icon icon-checkmark-black" style="width:15px"><use xlink:href="#icon-checkmark-black"></use></svg>
                            <span>{{ index+1 }}. {{ item.role_name }} w {{ item.place_name }}</span>
                        </p>
                        <ion-button
                                mode="ios"
                                fill="outline"
                                size="small"
                                style="vertical-align: middle"
                                @click="openPopover(item)">Edytuj rolę
                        </ion-button>
                        <ion-button
                                mode="ios"
                                size="small"
                                style="vertical-align: middle"
                                v-if="!item.verified"
                                @click="verifyUser($event,item)">
                            <svg class="icon icon-checkmark"><use xlink:href="#icon-checkmark"></use></svg>
                            <span>Zweryfikuj</span>
                        </ion-button>
                        <ion-button
                                mode="ios"
                                fill="outline"
                                size="small"
                                style="vertical-align: middle"
                                @click="removeUser($event,item)">Usuń
                        </ion-button>
                    </div>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="600" :delay="400">
                <div v-if="show" style="padding: 15px 0 15px">
                    <h6 class="text-up m-0">Ukończone szkolenia</h6>
                    <hr>
                    <div v-for="(item,index) in employee.certificates" :key="index">
                        <p>
                            <svg class="icon icon-checkmark"><use xlink:href="#icon-checkmark-black"></use></svg>&nbsp;
                            <span>{{ item.name }}</span>
                        </p>
                    </div>
                    <p v-if="employee.certificates && employee.certificates.length === 0">Brak ukończonych szkoleń.</p>
                </div>
            </slide-x-left-transition>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import goTo from '@/mixins/goto';
    import PageTitle from '@/components/PageTitle.vue';
    import ChangePlaceRolePopover from '@/popovers/ChangePlaceRolePopover.vue';

    export default {
        name: 'UserPlacesDetail',
        components: { PageTitle, ChangePlaceRolePopover },
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters('profile', ['getProfile']),
            ...mapState({
                errors: state => state.employees.errors,
                loading: state => state.employees.loading,
                data: state => state.employees.data,
                employee: state => state.employees.single,
                roles: state => state.global.roles
            }),

            progressValue(){
                return this.employee.number_pass_tests / this.employee.number_trainings_tests
            }
        },
        mounted() {
            this.findEmployeeSingle();

        },
        methods: {
            findEmployeeSingle(){
                let obj = this.data.find(x => x.employee_id === this.$route.params.slug);
                if(obj){
                    this.$store.commit('employees/USER_EMPLOYEE_SET_SINGLE', obj);
                    this.show = true
                }else{
                    this.$store.dispatch('employees/USER_EMPLOYEE_SINGLE_REQUEST', this.$route.params.slug).then(() => {
                        this.show = true
                    })
                }
            },
            openPopover(item){
                return this.$ionic.popoverController.create({
                    component: ChangePlaceRolePopover,
                    mode: 'ios',
                    componentProps: {
                        propsData: {
                            store: this.$store, // ionic bug: https://github.com/ModusCreateOrg/ionic-vue/issues/38#issuecomment-428247908
                            item: item,
                            place_slug_original: item.place_slug,
                            roles: this.roles,
                            employee: this.employee,
                            employee_slug: this.$route.params.slug
                        },
                    },
                }).then(m => m.present())
            },
            verifyUser(e,item){
                e.preventDefault();
                this.$ionic.alertController
                    .create({
                        header: 'Potwierdź',
                        message: 'Czy na pewno chcesz zweryfikować tego użytkownika?',
                        buttons: [
                            {
                                text: 'Anuluj',
                                role: 'cancel',
                            },
                            {
                                text: 'Tak',
                                handler: () => {
                                    return this.postVerifyEmployee(item);
                                }
                            }
                        ],
                        mode: 'md'
                    })
                    .then(a => a.present())
            },
            removeUser(e, item){
                e.preventDefault();
                this.$ionic.alertController
                    .create({
                        header: 'Potwierdź',
                        message: 'Czy na pewno chcesz usunąć tego użytkownika?',
                        buttons: [
                            {
                                text: 'Anuluj',
                                role: 'cancel',
                            },
                            {
                                text: 'Tak',
                                handler: () => {
                                    return this.postRemoveEmployee(item);
                                }
                            }
                        ],
                        mode: 'md'
                    })
                    .then(a => a.present())
            },
            postVerifyEmployee(item){
                let payload = {'employee_slug': this.$route.params.slug, 'place_slug': item.place_slug};
                this.$store.dispatch('employees/USER_EMPLOYEE_VERIFY_REQUEST', payload).then(resp => {
                    this.$store.dispatch('GLOBAL_TOAST','Zweryfikowano poprawnie.');
                });
            },
            postRemoveEmployee(item){
                let payload = {'employee_slug': this.$route.params.slug, 'place_slug': item.place_slug};
                this.$store.dispatch('employees/USER_EMPLOYEE_DELETE_REQUEST', payload).then(resp => {
                    this.$store.dispatch('GLOBAL_TOAST','Usunięto poprawnie.');
                    this.goBack();
                });
            }
        }
    }
</script>